import { render, staticRenderFns } from "./ChatContact.vue?vue&type=template&id=3b310138&scoped=true"
import script from "./ChatContact.vue?vue&type=script&lang=js"
export * from "./ChatContact.vue?vue&type=script&lang=js"
import style0 from "./ChatContact.vue?vue&type=style&index=0&id=3b310138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b310138",
  null
  
)

export default component.exports